export default __webpack_public_path__ + "img/sidebar_inventory.3c8a23e4.svg";